import React from 'react';
import { BookOpenIcon, FootprintsIcon, PenLineIcon } from 'lucide-react';
import { changeSteps } from '../../data/product';
const icons = {
  read: BookOpenIcon,
  reflect: PenLineIcon,
  act: FootprintsIcon
};
export function StepsSection() {
  return <section aria-labelledby="pasos-titulo" className="w-full border-t border-sand bg-ivory" data-id="element-178" data-mp="mzyyulrtct37">
      <div className="mx-auto max-w-6xl px-6 py-10 md:py-24 md:text-center lg:px-10 lg:py-32" data-id="element-179" data-mp="rz268cv9nbec">
        <h2 id="pasos-titulo" className="font-serif text-[30px] font-normal leading-[1.1] tracking-tight text-carbon md:text-4xl lg:text-[2.75rem]" data-id="element-180" data-mp="d6qgr6c2cd95">
          Tu cambio comienza en <em className="italic text-gold-ink" data-id="element-181" data-mp="45a8b44t6l7k">3 pasos</em>
        </h2>
        <p className="mt-3 max-w-md text-base leading-normal text-stone md:mx-auto md:mt-5 md:text-lg md:leading-relaxed" data-id="element-182" data-mp="89rqiyvisqg8">
          No necesitas tener todo resuelto. Solo decidir comenzar.
        </p>

        <ol className="relative mt-7 grid gap-6 md:mt-20 md:grid-cols-3 md:gap-10" data-id="element-183" data-mp="3vcd1u284d3ky">
          <span aria-hidden="true" className="absolute left-[16.66%] right-[16.66%] top-14 hidden h-px bg-sand md:block" data-id="element-184" data-mp="3sn1xnfh6kp9d" />
          {changeSteps.map((step, index) => {
          const Icon = icons[step.icon];
          return <li key={step.title} className="relative flex items-center gap-4 md:flex-col md:gap-0" data-id="element-185" data-mp="kk7tiy9d2au" data-mpi={index}>
                <div className="relative flex h-16 w-16 shrink-0 items-center justify-center rounded-full border border-gold bg-ivory md:h-28 md:w-28" data-id="element-186" data-mp="38zufr7otx1qj">
                  <Icon className="h-6 w-6 text-carbon md:h-9 md:w-9" strokeWidth={1.25} aria-hidden="true" data-id="element-187" data-mp="350daofdbe6lw" />
                  <span className="absolute -right-1 -top-1 flex h-[22px] w-[22px] items-center justify-center rounded-full bg-gold font-serif text-xs text-carbon md:right-[-4px] md:top-1 md:h-7 md:w-7 md:text-sm" data-id="element-188" data-mp="3is07cgb65h57">
                    {index + 1}
                  </span>
                </div>
                <div className="min-w-0 md:flex md:flex-col md:items-center" data-id="element-189" data-mp="2la9nfy6scs4l">
                  <h3 className="font-serif text-[21px] leading-tight text-carbon md:mt-8 md:text-2xl" data-id="element-190" data-mp="p6lozwvkd7vb">
                    <span className="sr-only" data-id="element-191" data-mp="u4wxa367nabf">Paso {index + 1}: </span>
                    {step.title}
                  </h3>
                  <p className="mt-0.5 line-clamp-2 text-[15px] leading-snug text-stone md:mt-2 md:max-w-[16rem] md:text-base md:leading-relaxed" data-id="element-192" data-mp="yzav0c8chtj9">
                    {step.body}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <p className="mt-7 font-serif text-base italic text-carbon md:mx-auto md:mt-20 md:max-w-md md:text-xl" data-id="element-193" data-mp="b85fxza8b5a0">
          <span className="mx-auto mb-6 hidden h-0.5 w-10 bg-gold md:block" aria-hidden="true" data-id="element-194" data-mp="g8t84oa71s5t" />
          21 días para practicar el valor de comenzar.
        </p>
      </div>
    </section>;
}